import Backbone from 'backbone';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileState from 'filestate/FileState';

export interface BaseFileAttributes {
  banner: React.ReactNode;
  fileState: FileState;
}

interface BaseFile {
  get<K extends keyof BaseFileAttributes>(key: K): BaseFileAttributes[K];
  set<K extends keyof BaseFileAttributes>(
    attributeName: K,
    value: BaseFileAttributes[K],
    options?: Backbone.ModelSetOptions
  ): BaseFile;
  set(obj: Partial<BaseFileAttributes>, options?: Backbone.ModelSetOptions): BaseFile;
}

class BaseFile extends Backbone.Model {
  editURL(): string {
    throw new Error(`editURL was not implemented by ${this.constructor.name}`);
  }
  setBanner(): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.setBannerText(null);
  }
  fileState(): FileState {
    return this.get('fileState');
  }
  fileType(): ModelTypeConstants {
    return this.fileState().fileType();
  }
  getBannerText(): React.ReactNode {
    return this.get('banner');
  }
  setBannerText(banner: React.ReactNode): void {
    this.set({banner});
  }
}

export default BaseFile;
